"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(path, data, defaultData) {
  return path.split(".").reduce(function (acc, item) {
    return acc && acc[item];
  }, data) || defaultData;
};

exports.default = _default;